import React from "react";
import { Phone, Mail, MapPin, Clock, Send } from "lucide-react";

const Contact = () => {
  return (
    <section className="relative w-full bg-white text-black">
      {/* Hero Background */}
      <div
         className="relative w-full h-[400px] bg-cover bg-center flex items-center justify-center
             bg-[url('https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1600&q=80')]"
         > 
        <div className="absolute inset-0 bg-black/60" />
        <div className="relative text-center text-white z-10">
          <h1 className="text-4xl md:text-5xl font-extrabold">Contact Us</h1>
          <p className="mt-3 text-lg max-w-2xl mx-auto text-gray-200">
            Ready to transform your architectural vision into reality?  
            Get in touch with our expert team today.
          </p>
        </div>
      </div>

      {/* Contact Info Cards */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-6 -mt-16 px-6 relative z-20">
        {[
          {
            icon: <MapPin size={28} />,
            title: "Office Address",
            text: (
              <>
                1 Baba Vishwanath Nagar Colony,<br />
                Ashokpuram Colony, Dafi, Varanasi
              </>
            ),
          },
          {
            icon: <Phone size={28} />,
            title: "Phone Number",
            text: (
              <>
                +91 7311118002<br />
                +91 9889690900
              </>
            ),
          },
          {
            icon: <Mail size={28} />,
            title: "Email Address",
            text: "brijadecoranddesigner@gmail.com",
          },
          {
            icon: <Clock size={28} />,
            title: "Working Hours",
            text: (
              <>
                Mon - Sat: 9 AM - 7 PM<br />
                Sunday: By Appointment
              </>
            ),
          },
        ].map((item, i) => (
          <div
            key={i}
            className="bg-white shadow-lg rounded-2xl p-6 flex flex-col items-center text-center border border-yellow-500 hover:shadow-yellow-500/50 hover:scale-105 transition"
          >
            <div className="p-4 bg-yellow-500 text-black rounded-full shadow-md">
              {item.icon}
            </div>
            <h4 className="mt-4 font-semibold text-lg text-yellow-600">{item.title}</h4>
            <p className="text-gray-700 mt-2 text-center">{item.text}</p>
          </div>
        ))}
      </div>

      {/* Form + Map */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 py-16 px-6">
        {/* Form */}
        <div className="bg-white shadow-lg rounded-2xl p-8 border border-yellow-500">
          <h3 className="text-2xl font-bold mb-6 text-yellow-600">Send Us a Message</h3>
          <form className="space-y-5">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input
                type="text"
                placeholder="Full Name"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg bg-white text-black focus:ring-2 focus:ring-yellow-500"
              />
              <input
                type="tel"
                placeholder="Phone Number"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg bg-white text-black focus:ring-2 focus:ring-yellow-500"
              />
            </div>
            <input
              type="email"
              placeholder="Email Address"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg bg-white text-black focus:ring-2 focus:ring-yellow-500"
            />
            <select className="w-full px-4 py-3 border border-gray-300 rounded-lg bg-white text-black focus:ring-2 focus:ring-yellow-500"
              aria-label="Select a service">
              <option>Select a service</option>
              <option>Architecture Design</option>
              <option>Interior Design</option>
              <option>Consultation</option>
            </select>
            <input
              type="text"
              placeholder="Subject"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg bg-white text-black focus:ring-2 focus:ring-yellow-500"
            />
            <textarea
              rows={5}
              placeholder="Message..."
              className="w-full px-4 py-3 border border-gray-300 rounded-lg bg-white text-black focus:ring-2 focus:ring-yellow-500"
            ></textarea>
            <button
              type="submit"
              className="w-full py-3 bg-yellow-500 text-black font-semibold rounded-lg hover:bg-yellow-600 flex items-center justify-center space-x-2 transition"
            >
              <Send size={18} />
              <span>Send Message</span>
            </button>
          </form>
        </div>

        {/* Map */}
        <div className="rounded-2xl overflow-hidden shadow-2xl border border-yellow-500">
          <iframe
            title="Braj PVC Manufacture and Wholesale Location"
            className="w-full h-full min-h-[500px]"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d249480.34390953404!2d82.78199213159444!3d25.2308496839173!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x398e33095ab775ef%3A0xefa9c540d2ab7d60!2sBraj%20PVC%20Manufacuture%20and%20Wholesale!5e0!3m2!1sen!2sin!4v1758300095554!5m2!1sen!2sin"
            //loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </section>
  );
};

export default Contact;
